import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import MuiModal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { SxProps, Theme, useTheme } from '@mui/material';

export type ModalProps = {
    open: boolean;
    onClose: () => void;
    children: React.ReactNode | ((onClose: ModalProps["onClose"]) => React.ReactNode);
    sx?: SxProps<Theme>;
}

export const getStyles = (theme: Theme): SxProps<Theme> => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    bgcolor: theme.palette.background.default,
    p: 2,
    borderRadius: `${theme.shape.borderRadius}px`,
});

export const Modal = ({ open, onClose, children, sx = {} }: ModalProps) => {
    const theme = useTheme();

    const defaultStyles = getStyles(theme);

    const styles = { ...defaultStyles, ...sx };

    const isReactNode = React.isValidElement(children);

    return (
        <MuiModal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={onClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 250,
                },
            }}
            sx={{ zIndex: theme.zIndex.drawer * 7 }}
        >
            <Fade in={open}>
                <Box sx={styles}>
                    {isReactNode ? children : (children as Function)(onClose)}
                </Box>
            </Fade>
        </MuiModal>
    );
}